// Completitud TOTAL de un producto (no sólo lo que exige la tienda):
// identificación, ficha técnica, los 5 precios, fotos y tienda en línea.
// Cada grupo corresponde a un paso del ProductForm (id = pf-<step>).
const txt = (v) => !!String(v ?? "").trim();
const pos = (v) => Number(v || 0) > 0;

export const GROUP_META = {
  basic:  { label: "Datos",   step: "basic",  short: "Datos" },
  specs:  { label: "Ficha",   step: "specs",  short: "Ficha" },
  prices: { label: "Precios", step: "stock",  short: "Precios" },
  photos: { label: "Fotos",   step: "photos", short: "Fotos" },
  store:  { label: "Tienda",  step: "store",  short: "Tienda" },
};

export function productCompleteness(p, specTemplate = []) {
  const photos = Array.isArray(p.photos) ? p.photos.filter(Boolean) : [];
  const specs = p.specs || {};
  const groups = [
    { id: "basic", slots: [
      { key: "name", label: "Nombre", ok: txt(p.name) },
      { key: "category", label: "Categoría", ok: txt(p.category) },
      { key: "brand", label: "Marca", ok: txt(p.brand) },
      { key: "characteristics", label: "Descripción / características", ok: txt(p.characteristics) },
    ] },
    { id: "specs", slots: [] },
    { id: "prices", slots: [
      { key: "cost", label: "Costo", ok: pos(p.cost) },
      { key: "min_price", label: "Precio mínimo", ok: pos(p.min_price) },
      { key: "reseller_price", label: "Precio reventa", ok: pos(p.reseller_price) },
      { key: "marketplace_price", label: "Precio distribuidor", ok: pos(p.marketplace_price) },
      { key: "store_price", label: "Precio tienda", ok: pos(p.store_price) },
    ] },
    { id: "photos", slots: [
      { key: "photos", label: "Al menos 1 foto", ok: photos.length > 0 || txt(p.photos_url) || txt(p.cover_photo) },
    ] },
    { id: "store", slots: [
      { key: "short_tagline", label: "Slogan corto", ok: txt(p.short_tagline) },
      { key: "use_cases", label: "Uso ideal", ok: (p.use_cases || []).length > 0 },
      { key: "aesthetic_grade", label: "Grado estético", ok: txt(p.aesthetic_grade) },
      { key: "seo", label: "SEO (título y descripción)", ok: txt(p.meta_title) && txt(p.meta_description) },
    ] },
  ];
  const req = (specTemplate || []).filter((f) => f.required);
  const specGroup = groups[1];
  if (req.length > 0) {
    req.forEach((f) => specGroup.slots.push({ key: `spec_${f.key}`, label: f.label, ok: txt(specs[f.key]) }));
  } else if ((specTemplate || []).length > 0) {
    specGroup.slots.push({ key: "specs", label: "Al menos 1 dato de ficha", ok: Object.values(specs).some(txt) });
  }
  // Sin esquema para la categoría la ficha no cuenta (no hay campos que llenar).

  const out = groups.filter((g) => g.slots.length > 0).map((g) => {
    const missing = g.slots.filter((s) => !s.ok);
    return { id: g.id, ...GROUP_META[g.id], total: g.slots.length, filled: g.slots.length - missing.length, missing, complete: missing.length === 0 };
  });
  const total = out.reduce((a, g) => a + g.total, 0);
  const filled = out.reduce((a, g) => a + g.filled, 0);
  const missing = out.flatMap((g) => g.missing.map((m) => ({ ...m, group: g.id, groupLabel: g.label })));
  return {
    groups: out, total, filled, missing,
    missingGroups: out.filter((g) => !g.complete).map((g) => g.id),
    pct: total ? Math.round((filled / total) * 100) : 100,
    complete: missing.length === 0,
  };
}

// Opciones del filtro "Completitud" en Productos.
export const COMPLETENESS_FILTERS = [
  { value: "all", label: "Completitud: todos" },
  { value: "incomplete", label: "Falta algo" },
  { value: "complete", label: "100 % completos" },
  { value: "missing_photos", label: "Sin fotos" },
  { value: "missing_prices", label: "Precios incompletos" },
  { value: "missing_basic", label: "Sin descripción / marca" },
  { value: "missing_specs", label: "Ficha técnica incompleta" },
  { value: "missing_store", label: "Tienda incompleta" },
];

export function matchesCompleteness(c, filter) {
  if (filter === "all") return true;
  if (filter === "complete") return c.complete;
  if (filter === "incomplete") return !c.complete;
  if (filter.startsWith("missing_")) return c.missingGroups.includes(filter.slice(8));
  return true;
}
